import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import ListProd from "./pages/list/ListProd";
import ListOrders from "./pages/list/ListOrders";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import { userInputs, productInputs } from "./formSource";
import "./style/dark.css";
import { DarkModeContext } from "./context/darkModeContext";
import NewProduct from "./pages/new/NewProduct";

function AdminApp() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/users" element={<List />} />
        <Route path="/users/:userId" element={<Single />} />
        <Route path="/users/new" element={<New inputs={userInputs} title="Add New User" />} />
        <Route path="/products" element={<ListProd />} />
        <Route path="/products/:productId" element={<Single />} />
        <Route path="/products/newProduct" element={<NewProduct />} />
        <Route path="/orders" element={<ListOrders />} />

      </Routes>
    </div>
  );
}

export default AdminApp;
